import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas, faSearch } from "@fortawesome/free-solid-svg-icons";

import "assets/styles/tailwind.css";

// Component
import App from "./App";

import { store } from "app/store";
import { Provider } from "react-redux";
library.add(fab, fas, faSearch);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
